import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';

import { Tag } from 'components/ui';
import { type AssetColorStatus, getAssetColorStatus } from 'utils/color/helpers';

interface IStatusTagProps {
  value: string;
}

export const StatusTag: React.FunctionComponent<IStatusTagProps> = ({ value, ...props }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  // FIXME JD: Once we've removed all of the old PAPI-dependent turbine tables, remove this logic.
  // Account for older usage of the StatusTag: 'ACTIVE' and 'INACTIVE' are valid inputs that should be mapped to 'Online' and 'Offline' respectively.
  // `statusKey` stays in English: it is the identifier passed to getAssetColorStatus (an
  // AssetColorStatus comparison key). Only the visible label is translated.
  const statusKey = value === 'ACTIVE' ? 'Online' : value === 'INACTIVE' ? 'Offline' : value;
  const displayLabel =
    statusKey === 'Online'
      ? t('table.online', 'Online')
      : statusKey === 'Offline'
        ? t('table.offline', 'Offline')
        : statusKey;
  return (
    <StyledTag color={getAssetColorStatus(statusKey as AssetColorStatus, theme)} {...props}>
      {displayLabel.toUpperCase()}
    </StyledTag>
  );
};

/**
 * The color prop for antd's `<Tag />` is for the backound color, but there is
 * no text or border color prop. When the background is white, set the text and
 * border to black.
 */
const StyledTag = styled(Tag)<{ color: string }>`
  ${({ color, theme }) =>
    color === theme.secondaryBackgroundColor &&
    `
    border: 1px solid ${theme.contrastColor};
    color: ${theme.contrastColor};
    font-size: 10px;
  `}
`;
